// extracted by css-extract-rspack-plugin
export default {"cls1":"CourseResults-cls1_7Ed","cls2":"CourseResults-cls2_ceu CourseResults-cls1_7Ed"};